export default "__VITE_ASSET__VB6pGd_t__"